// extracted by mini-css-extract-plugin
export default {"details":"i4jHPY48R4GtaIeSOWkF","information":"kgwVGAbUaH04H9cRMAk7","information_row":"t2l7QDf0mAUUR8h9LSfA","total_block":"amPaPAbcbzeBvjBwbtWD","title":"KNfUDRCZJOD6ptmFj0Lj"};